module.exports = __webpack_public_path__ + "static/img/74060F_2_3_R_20200712_LC.07d669a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/74060F_2_3_R_20200712_LC.png
// module id = E0Lu
// module chunks = 0